// extracted by mini-css-extract-plugin
export default {"OfferCollectionModal":"OfferCollectionModal_OfferCollectionModal__OAEwI","Text":"OfferCollectionModal_Text__LSsf6","whale":"OfferCollectionModal_whale__1an2i"};